/* eslint-disable @typescript-eslint/no-shadow */
import { Action } from '@ngrx/store';
import { Config } from '../../models/invoices/segments.config.model';

export enum ActionTypes {
  Update = '[Account Segments] Update config',
  Receive = '[Account Segments] Receive config',
  Reset = '[Account Segments] Reset config'
}

export class Update implements Action {
  readonly type = ActionTypes.Update;
}

export class Receive implements Action {
  readonly type = ActionTypes.Receive;
  constructor(public payload: { config: Config; errorMessage: string }) {}
}

export class Reset implements Action {
  readonly type = ActionTypes.Reset;
}

export type ActionList = Update | Receive | Reset;
